import { Grid } from '@mui/material';
import PaymentInformation from 'models/PaymentInformation';
import React, { useEffect, useState } from 'react';
import { useUserContext } from 'UserContext';
import { PayBackgroundPaper } from './PayPapers';
import PaySectionHeader from './PaySectionHeader';
import { Text, OutlinedDropdown } from 'library';
import ManualConfirmation from '../setup/ManualConfirmation';
import { client, consoleLogInDev } from 'shared';
import { ISetupData } from '../models';
import SetupIntentInfo from '../setup/SetupIntentInfo';

export default function MicrodepositsEntry() {
    const [selectedAccount, setSelectedAccount] = useState('');
    const [setupData, setSetupData] = useState<ISetupData>();

    const { user } = useUserContext();
    const paymentSetup = user?.payment_information;

    const accountsToVerify = paymentSetup?.filter((x: PaymentInformation) => x.status === 'NEW');
    const accountOptions = accountsToVerify?.map((x) => {
        return { key: x.id.toString(), value: x.last_four || '' };
    });

    const options = [{ key: '0', value: 'Select Account' }, ...(accountOptions || [])];

    useEffect(() => {
        if (accountOptions?.length) {
            setSelectedAccount(accountOptions[0].key);
        }
    }, [paymentSetup]);

    useEffect(() => {
        if (selectedAccount && selectedAccount !== '0') {
            client(`payment/api/pay-setup/${selectedAccount}/setup-intent/`)
                .then((response) => {
                    setSetupData(response);
                })
                .catch(consoleLogInDev);
        }
    }, [selectedAccount]);

    const instructions = setupData
        ? 'You\'ll recieve a single deposit for $0.01 with a descriptor code that starts with "SM". Follow the link once you receive it to complete your account setup. Refresh page when complete.'
        : "You'll receive two deposits and withdrawals, each less than $1, on your bank statement over the next three days. Please verify the amounts to complete your account setup.";

    return accountsToVerify?.length ? (
        <Grid item md={12}>
            <PayBackgroundPaper>
                <PaySectionHeader>Manual Account Verification</PaySectionHeader>
                <Text variant="body1">{instructions}</Text>
                <Grid container direction="row" alignItems="center" style={{ padding: 5 }}>
                    <Text variant="body2" textStyle={{ marginRight: 5 }}>
                        Account Ending In:
                    </Text>
                    <OutlinedDropdown
                        fields={options}
                        value={selectedAccount || ''}
                        onChange={(x) => setSelectedAccount(x.target.value)}
                        displayEmpty
                    />
                </Grid>
                {setupData ? (
                    <SetupIntentInfo setupData={setupData} />
                ) : (
                    <ManualConfirmation paymentInfoId={parseInt(selectedAccount)} />
                )}
            </PayBackgroundPaper>
        </Grid>
    ) : null;
}
